import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../inscribete/inscripcion.css';
import { db } from '../../../server/api';
import { doc, setDoc } from 'firebase/firestore';
import ModalInformativo from '../../modales/modalinformativo';
import tratamientoContenido from '../../texto/tratamientodedatos.txt';
import logo from '../../images/ensenartecorto.png';
import RuletaPromo from './RuletaPromo';
import { showToast } from '../../toastify/ToastContainer';

const getTodayDocId = () => {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = now.getFullYear();
  return `${dd}_${mm}_${yyyy}`;
};

const formatPhone = (digits) => {
  const d = digits.replace(/\D/g, '').slice(0, 10);
  if (!d) return '';
  const part1 = d.slice(0, 3);
  const part2 = d.slice(3, 6);
  const part3 = d.slice(6, 8);
  const part4 = d.slice(8, 10);
  const sections = [part1, part2, part3, part4].filter(Boolean);
  return sections.join(' ');
};

const InteresPage = () => {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState('');
  const [correo, setCorreo] = useState('');
  const [telefono, setTelefono] = useState('');
  const [aceptaTratamiento, setAceptaTratamiento] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [contenidoTratamiento, setContenidoTratamiento] = useState('');
  const [mostrarRuleta, setMostrarRuleta] = useState(false);
  const [yaEnvioInteres, setYaEnvioInteres] = useState(false);
  const [descuentoObtenido, setDescuentoObtenido] = useState(null);

  useEffect(() => {
    fetch(tratamientoContenido)
      .then((res) => res.text())
      .then((text) => setContenidoTratamiento(text))
      .catch((err) => console.error('Error cargando tratamiento:', err));
  }, []);

  // Verificar si ya envió interés anteriormente y si tiene descuento
  useEffect(() => {
    const docId = getTodayDocId();
    const storageKey = `INTERESADOS_${docId}`;
    const data = localStorage.getItem(storageKey);

    if (data) {
      try {
        const parsed = JSON.parse(data);
        // Si hay datos guardados, significa que ya envió interés hoy
        if (Object.keys(parsed).length > 0) {
          setYaEnvioInteres(true);
        }
      } catch (e) {
        console.error('Error parsing localStorage:', e);
      }
    }

    // Verificar si ya tiene descuento de ruleta
    const ruletaData = localStorage.getItem("ruletaPromo");
    if (ruletaData) {
      try {
        const parsed = JSON.parse(ruletaData);
        if (parsed.descuento) {
          setDescuentoObtenido(parsed.descuento);
        }
      } catch (e) {
        console.error('Error parsing ruleta data:', e);
      }
    }

    // Mostrar ruleta solo si no ha enviado interés Y no tiene descuento
    if (!yaEnvioInteres && !descuentoObtenido) {
      setMostrarRuleta(true);
    }
  }, [yaEnvioInteres, descuentoObtenido]);

  const handleDescuentoObtenido = (descuento) => {
    setDescuentoObtenido(descuento);
  };



  const onNombreChange = (event) => {
    const value = event.target.value.toUpperCase();
    setNombre(value);
  };

  const onCorreoChange = (event) => {
    const value = event.target.value.toLowerCase();
    setCorreo(value);
  };

  const onTelefonoChange = (event) => {
    const value = event.target.value.replace(/\D/g, '').slice(0, 10);
    setTelefono(value);
  };

  const submitHandler = (event) => {
    event.preventDefault();

    const nombreTrim = nombre.trim();
    const telefonoRaw = telefono.replace(/\D/g, '');

    if (!nombreTrim) {
      showToast('El nombre completo es obligatorio.', 'error');
      return;
    }

    if (telefonoRaw.length !== 10) {
      showToast('El número de teléfono debe tener exactamente 10 dígitos.', 'error');
      return;
    }

    if (!aceptaTratamiento) {
      showToast('Debes aceptar el tratamiento de datos para continuar.', 'error');
      return;
    }

    const docId = getTodayDocId();
    const storageKey = `INTERESADOS_${docId}`;

    let current = {};
    try {
      current = JSON.parse(localStorage.getItem(storageKey) || '{}');
      if (typeof current !== 'object' || current === null) {
        current = {};
      }
    } catch (e) {
      current = {};
    }

    const userKey = `user_${Date.now()}`;
    const userData = {
      nombre: nombreTrim,
      correo: correo.trim(),
      telefono: telefonoRaw,
      descuento: descuentoObtenido,
      creado: new Date().toISOString(),
    };

    current[userKey] = userData;
    localStorage.setItem(storageKey, JSON.stringify(current));

    // Guarda en Firestore con campo mapa por usuario y docId por día
    const docRef = doc(db, 'INTERESADOS', docId);
    setDoc(docRef, { [userKey]: userData }, { merge: true })
      .then(() => {
        console.log('Firestore INTERESADOS guardado', docId, userKey, userData);
      })
      .catch((err) => {
        console.error('Error guardando en Firestore:', err);
        showToast('No se pudo guardar en la nube. Intenta nuevamente.', 'error');
      });

    // Mensaje de éxito
    showToast('Gracias por tu interés. En breves te contactaremos.', 'success');
    setNombre('');
    setCorreo('');
    setTelefono('');
    setYaEnvioInteres(true); // Marcar que ya envió interés
    setMostrarRuleta(false); // Ocultar ruleta
    
    // Redirigir a /landingpage después de 1.5 segundos
    setTimeout(() => {
      navigate('/landingpage');
    }, 1500);
  };

  return (
    <>
      <section className="inscripcion-container">
        <div className="inscripcion-content">
          <div className="inscripcion-header">
            <img src={logo} alt="EnsenArte" className="inscripcion-logo" />
            <h1 className="inscripcion-title">Únete a nuestra comunidad</h1>
            <p className="inscripcion-subtitle">Mantente al tanto de nuestras novedades y ofertas especiales.💙</p>
          </div>

          <form className="inscripcion-form" onSubmit={submitHandler} noValidate>
            <div className="inscripcion-grid">
              <label className="inscripcion-label">
                Nombre completo *
                <input
                  className="inscripcion-input"
                  type="text"
                  value={nombre}
                  onChange={onNombreChange}
                  placeholder="JUAN PEREZ"
                  autoComplete="name"
                  required
                />
              </label>

              <label className="inscripcion-label">
                Correo electrónico
                <input
                  className="inscripcion-input"
                  type="email"
                  value={correo}
                  onChange={onCorreoChange}
                  placeholder="correo@dominio.com"
                  autoComplete="email"
                />
              </label>

              <label className="inscripcion-label">
                Teléfono (10 dígitos) *
                <input
                  className="inscripcion-input"
                  type="text"
                  value={formatPhone(telefono)}
                  onChange={onTelefonoChange}
                  placeholder="123 456 78 90"
                  inputMode="numeric"
                  maxLength={13}
                  required
                />
              </label>

              {descuentoObtenido && (
                <label className="inscripcion-label">
                  Descuento aplicado 🎉
                  <input
                    className="inscripcion-input descuento-input"
                    type="text"
                    value={`${descuentoObtenido}% OFF`}
                    readOnly
                    style={{ backgroundColor: '#f0f8ff', fontWeight: 'bold', color: '#2e7d32' }}
                  />
                </label>
              )}
            </div>

            <div className="checkbox-wrapper-30" style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
              <span className="checkbox">
                <input
                  type="checkbox"
                  checked={aceptaTratamiento}
                  onChange={() => setModalOpen(true)}
                />
                <svg>
                  <use xlinkHref="#checkbox-30" className="checkbox"></use>
                </svg>
              </span>
              <label
                className="formulario-checkbox-text"
                onClick={() => setModalOpen(true)}
              >
                Acepto que he leído sobre el tratamiento de datos *
              </label>
              <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                <symbol id="checkbox-30" viewBox="0 0 22 22">
                  <path fill="none" stroke="currentColor" d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"/>
                </symbol>
              </svg>
            </div>

            <button type="submit" className="inscripcion-submit-btn">Enviar interés</button>
          </form>

          <div className="formulario-extra">
            <p>¿Ya formas parte? <strong>No te lo pierdas</strong>.</p>
            <a className="formulario-extra-link" href="https://ensenarteonline.com.co" target="_blank" rel="noreferrer">Visita nuestra comunidad</a>
          </div>
        </div>
      </section>

      {/* Ruleta Promocional - Solo se muestra si no ha enviado interés hoy */}
      {mostrarRuleta && <RuletaPromo onDescuentoObtenido={handleDescuentoObtenido} />}

      {/* Modal Informativo de Tratamiento de Datos */}
      <ModalInformativo
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onAccept={() => setAceptaTratamiento(true)}
        titulo="Términos y Condiciones – Tratamiento de Datos Personales"
        contenido={contenidoTratamiento}
      />
    </>
  );
};

export default InteresPage;